const NewsSearchTypes = {
    CHANGE_NEWS_SEARCH_VALUE:'CHANGE_NEWS_SEARCH_VALUE',
    GET_NEWS_SEARCH_START:'GET_NEWS_SEARCH_START',
    GET_NEWS_SEARCH_SUCCESS:'GET_NEWS_SEARCH_SUCCESS',
    GET_NEWS_SEARCH_FAILED:'GET_NEWS_SEARCH_FAILED',
    CHANGE_NEWS_SEARCH_STATE:'CHANGE_NEWS_SEARCH_STATE'
}

export default NewsSearchTypes